import React from 'react';
import toast from 'react-hot-toast';
import { CheckCircle2, AlertTriangle, Info, Loader2, X } from 'lucide-react';

/**
 * Avisos do sistema: card escuro no canto inferior direito (acima da ilha no
 * celular), com ícone, barra de tempo e saída animada.
 */
const CORES = {
  success: { cor: '#45D4A8', borda: 'rgba(69,212,168,0.45)', fundo: 'rgba(69,212,168,0.16)', Icone: CheckCircle2 },
  error:   { cor: '#F87171', borda: 'rgba(248,113,113,0.45)', fundo: 'rgba(248,113,113,0.16)', Icone: AlertTriangle },
  info:    { cor: '#5B9BFF', borda: 'rgba(91,155,255,0.45)',  fundo: 'rgba(91,155,255,0.16)',  Icone: Info },
  loading: { cor: '#9B6BFF', borda: 'rgba(155,107,255,0.45)', fundo: 'rgba(155,107,255,0.16)', Icone: Loader2 },
};

const DURACAO = { success: 4000, error: 6000, info: 4500 };

const Card = ({ t, tipo, mensagem, duracao }) => {
  const { cor, borda, fundo, Icone } = CORES[tipo] || CORES.info;
  return (
    <div
      className={`pointer-events-auto relative w-[min(92vw,360px)] overflow-hidden rounded-[13px] border-2 bg-[#13101C] shadow-[0_14px_40px_rgba(0,0,0,0.6)] ${
        t.visible ? 'toast-entra' : 'toast-sai'
      }`}
      style={{ borderColor: borda }}
    >
      <div className="flex items-start gap-2.5 px-3.5 py-3">
        <span className="w-7 h-7 rounded-[9px] flex items-center justify-center flex-shrink-0"
              style={{ background: fundo, color: cor }}>
          <Icone size={15} className={tipo === 'loading' ? 'animate-spin' : ''} />
        </span>
        <p className="flex-1 text-[13px] leading-snug text-[#ECE9F3] pt-0.5">{mensagem}</p>
        {tipo !== 'loading' && (
          <button onClick={() => toast.dismiss(t.id)} aria-label="Fechar" className="text-[#6E667F] hover:text-white flex-shrink-0">
            <X size={15} />
          </button>
        )}
      </div>
      {tipo !== 'loading' && (
        <span
          className="absolute bottom-0 left-0 h-[3px] toast-barra"
          style={{ background: cor, animationDuration: `${duracao}ms` }}
        />
      )}
    </div>
  );
};

const mostrar = (tipo, mensagem) => {
  const duracao = DURACAO[tipo] || 4000;
  return toast.custom(
    (t) => <Card t={t} tipo={tipo} mensagem={mensagem} duracao={duracao} />,
    { duration: duracao, position: 'bottom-right' }
  );
};

export const showToast = {
  success: (message) => mostrar('success', message),
  error: (message) => mostrar('error', message),
  info: (message) => mostrar('info', message),
  activated: (message) => mostrar('success', message),
  loading: (message) => toast.custom(
    (t) => <Card t={t} tipo="loading" mensagem={message} duracao={0} />,
    { duration: Infinity, position: 'bottom-right' }
  ),
  dismiss: (toastId) => toast.dismiss(toastId),
};

export default showToast;
